export default __webpack_public_path__ + "static/media/348.21f96425.png";